import React from 'react';
import Head from 'next/head';

const config = require('@/config/config.js');

const PageHead: React.FC = () => {
  return (
    <Head>
      <>
        <meta
          name="keywords"
          content="黄鸡、小黄鸡、碧蓝、碧蓝航线、即时海战、Azur Lane、蛮啾、蛮啾网络、蓝原、星原、旅谣、蓝色星原旅谣、蓝色星原、蛮啾游戏、蛮啾手游、黄鸡游戏、黄鸡手游、蓝原、AL、蛮秋、manjuu、manjuugames、MANJUU、MANJUUGAMES、MANJUU招聘、蛮啾招聘、二次元游戏公司招聘、蛮啾网络招聘、碧蓝招聘、碧蓝航线招聘、蓝色星原招聘、黄鸡招聘、小黄鸡招聘"
        />
        <meta
          name="description"
          content="是一家由一群年轻的ACG爱好者所组成的新兴游戏公司。我们的共同目标是：做最有趣的二次元游戏。"></meta>
      </>
      <meta
        name="viewport"
        content="initial-scale=1, maximum-scale=1, user-scalable=no, width=device-width"
      />
      <meta
        name="theme-color"
        media="(prefers-color-scheme: light)"
        content={config.ThemeColor}></meta>
      <link rel="icon" href="/favicon.ico" />
      <meta property="og:image" content="/og.png" />
      <meta property="og:title" content="Manjuu Games 蛮啾网络" />
      <meta
        property="og:description"
        content="[Manjuu Games 蛮啾网络]：你的职场新坐标！"
      />
      <title>加入 Manjuu Games</title>
    </Head>
  );
};

export default PageHead;
